import {
  ListItemIcon,
  MenuItem,
  Typography,
  SvgIconProps,
} from "@mui/material";
import { FONT_COLORS } from "../../../../constants";
import CircularProgress from "../../../CircularProgress";

type TMenuLinkProps = {
  label: string;
  renderIcon?: (props: SvgIconProps) => React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
};

export const MenuLink = ({
  label,
  renderIcon,
  onClick,
  loading,
  disabled,
}: TMenuLinkProps) => {
  return (
    <MenuItem onClick={onClick} disabled={disabled || loading}>
      {loading ? (
        <ListItemIcon>
          <CircularProgress size="md" />
        </ListItemIcon>
      ) : (
        renderIcon && (
          <ListItemIcon>
            {renderIcon({ sx: { fontSize: 24, color: FONT_COLORS.label } })}
          </ListItemIcon>
        )
      )}
      <Typography fontSize={14} color={FONT_COLORS.label}>
        {label}
      </Typography>
    </MenuItem>
  );
};
